$(document).ready(function(){
    $('.owl-carousel').owlCarousel({
        dots: true,
        loop:true,
        margin:10,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            800:{
                items:2
            },
            1200:{
                items:3
            }
        },
        navText: [
            '<iconify-icon icon="majesticons:arrow-left-line" width="24" height="24"></iconify-icon>', // Botón izquierdo
            '<iconify-icon icon="majesticons:arrow-right" width="24" height="24"></iconify-icon>' // Botón derecho
        ]
    })
});
